/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PremiumRoleEntity } from './premiumRoleEntity';
import { GeoLocationEntity } from './geoLocationEntity';
import { UserSportTypeLevel } from './userSportTypeLevel';
import { NotificationsEntity } from './notificationsEntity';
import { CommissionEntity } from './commissionEntity';
import { UserEntity } from './userEntity';


export interface UserProfilePopulatedEntity { 
    __init: boolean;
    lastLoginAt?: string;
    locationEnabled?: boolean;
    appearInNearbyCount?: boolean;
    locationCity?: string;
    _id?: string;
    user: UserEntity;
    createdAt?: string;
    avatarUrl: string;
    city: string;
    country: string;
    language?: string;
    dateOfBirth: string;
    description: string;
    timezone: string;
    firstName: string;
    followers: Array<string>;
    followings: Array<string>;
    lastName: string;
    phone?: string;
    likeds: Array<string>;
    location: GeoLocationEntity;
    privacy?: UserProfilePopulatedEntity.PrivacyEnum;
    pushToken: string;
    sex: string;
    sportLevels: Array<UserSportTypeLevel>;
    historicSportLevels: Array<UserSportTypeLevel>;
    unlikeds: Array<string>;
    userId: string;
    userMatchs: Array<string>;
    work: string;
    zipCode: string;
    isMyLastNameAnonymised: boolean;
    notifications?: NotificationsEntity;
    premiumRole?: PremiumRoleEntity;
    commissionPercent?: number | null;
    acceptedCommission?: boolean;
    acceptedGcs?: boolean;
    commissionId?: string;
    commission?: CommissionEntity;
    lastPushToken?: string;
    liveLocation?: GeoLocationEntity;
}
export namespace UserProfilePopulatedEntity {
    export type PrivacyEnum = 'public' | 'private' | 'hidden';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        Hidden: 'hidden' as PrivacyEnum
    };
}


